module.exports = __webpack_public_path__ + "static/media/musos_logo.2fdb3d06.png";